import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../API/axiosInstance";
import { toast, ToastContainer, Bounce } from 'react-toastify';
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import "./userRegister.css"; // Make sure to import your CSS
import "react-toastify/dist/ReactToastify.css";
import { BsEye, BsEyeSlash, BsInfoCircle } from "react-icons/bs";

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    whatsapp_mobileNo: "",
    mobileNo: "",
    dob: "",
    gender: "",
    address: "",
    termsAccepted: false,
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isWhatsappSame, setIsWhatsappSame] = useState(false);

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const notify = (status, message) => {
    const options = {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    };
    if (status === "success") {
      toast.success(message, options);
    } else {
      toast.error(message, options);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.firstname) newErrors.firstname = "First Name is required";
    if (!formData.lastname) newErrors.lastname = "Last Name is required";
    if (!formData.username) newErrors.username = "Username is required";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.email = "Invalid email format";
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else {
      if (formData.password.length < 8) {
        newErrors.password = "Password must be at least 8 characters long.";
      }
      if (!/[A-Z]/.test(formData.password)) {
        newErrors.password = "Password must contain at least one uppercase letter.";
      }
      if (!/[a-z]/.test(formData.password)) {
        newErrors.password = "Password must contain at least one lowercase letter.";
      }
      if (!/\d/.test(formData.password)) {
        newErrors.password = "Password must contain at least one number.";
      }
      if (!/[@$!%*?&]/.test(formData.password)) {
        newErrors.password = "Password must contain at least one special symbol (@$!%*?&).";
      }
    }
    if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
    if (!formData.mobileNo.match(/^\d{10}$/)) newErrors.mobileNo = "Mobile number must be 10 digits";
    if (!formData.termsAccepted) newErrors.termsAccepted = "You must accept the terms";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    if (isWhatsappSame) {
      setFormData(prevFormData => ({
        ...prevFormData,
        whatsapp_mobileNo: prevFormData.mobileNo
      }));
    } else {
      setFormData(prevFormData => ({
        ...prevFormData,
        whatsapp_mobileNo: ''
      }));
    }
  }, [isWhatsappSame, formData.mobileNo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (validateForm()) {
      try {
        console.warn(JSON.stringify(formData));
        const response = await axiosInstance.post("/user/register", formData);
        if (response.status === 201) {
          notify("success", "Registration Successful! Redirecting to login...");
          setTimeout(() => navigate("/user-login"), 2000);
        }
        setLoading(false);

      } catch (err) {
        setLoading(false);
        notify("error", err.response?.data?.message || "Registration failed. Please try again.");
        console.error(err);
      }
    } else {
      setLoading(false);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleCheckboxChange = (e) => {
    setIsWhatsappSame(e.target.checked);
  };

  return (
    <div className="registration-container d-flex justify-content-center align-items-center">
      <ToastContainer />
      <Card className="registration-card">
        <Card.Body>
          <h1 className="text-center registration-header">Create an Account</h1>
          <Form noValidate onSubmit={handleSubmit}>
            <Row className="mt-2 d-flex align-items-center justify-content-center h-auto gx-3">
              <Form.Group as={Col} md={6} className="mt-md-0 p-1 form-group-fixed-height" controlId="firstname">
                <Form.Floating>
                  <Form.Control type="text" name="firstname" placeholder="First Name" onChange={handleChange} isInvalid={!!errors.firstname} required />
                  {/* Added red asterisk */}
                  <label htmlFor="firstname">First Name <span className="text-danger">*</span></label>
                  <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                </Form.Floating>
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="lastname" className="mt-md-0 p-1 form-group-fixed-height">
                <Form.Floating>
                  <Form.Control type="text" name="lastname" placeholder="Last Name" onChange={handleChange} isInvalid={!!errors.lastname} required />
                  <label htmlFor="lastname">Last Name <span className="text-danger">*</span></label>
                  <Form.Control.Feedback type="invalid">{errors.lastname}</Form.Control.Feedback>
                </Form.Floating>
              </Form.Group>
            </Row>

            <Row className="mt-2 h-auto gx-3">
              <Form.Group as={Col} md={6} controlId="username2" className="mt-md-0 p-1 form-group-fixed-height">
                <Form.Floating>
                  <Form.Control
                    type="text"
                    name="username"
                    placeholder="Username"
                    onChange={handleChange}
                    isInvalid={!!errors.username}
                    required
                  />
                  <label htmlFor="username">Username <span className="text-danger">*</span></label>
                  <Form.Control.Feedback type="invalid">{errors.username}</Form.Control.Feedback>
                </Form.Floating>

                <Form.Text muted className="d-flex align-items-center">
                  <BsInfoCircle className="me-2" /> {/* Icon with margin */}
                  Use valid usernames.
                </Form.Text>

              </Form.Group>
              <Form.Group as={Col} md={6} controlId="email" className="mt-md-0 p-1 form-group-fixed-height">
                <Form.Floating>
                  <Form.Control type="email" name="email" placeholder="name@example.com" onChange={handleChange} isInvalid={!!errors.email} required />
                  <label htmlFor="email">Email address <span className="text-danger">*</span></label>
                  <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                </Form.Floating>
              </Form.Group>
            </Row>

            <Row className="mt-2 d-flex align-items-center justify-content-center h-auto gx-3">
              <Form.Group as={Col} md={6} controlId="password" className="mt-md-0 p-1 form-group-fixed-height">
                <div className="password-field-wrapper">
                  <Form.Floating>
                    <Form.Control
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder="Password"
                      onChange={handleChange}
                      isInvalid={!!errors.password}
                      required
                    />
                    <label htmlFor="password">Password <span className="text-danger">*</span></label>
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Floating>
                  <span onClick={togglePasswordVisibility} className="password-toggle-icon">
                    {showPassword ? <BsEye size={20} /> : <BsEyeSlash size={20} />}
                  </span>
                </div>
              </Form.Group>

              <Form.Group as={Col} md={6} controlId="confirmPassword" className="mt-md-0 p-1 form-group-fixed-height">
                <div className="password-field-wrapper">
                  <Form.Floating>
                    <Form.Control
                      type={showConfirmPassword ? 'text' : 'password'}
                      name="confirmPassword"
                      placeholder="Confirm Password"
                      onChange={handleChange}
                      isInvalid={!!errors.confirmPassword}
                      required
                    />
                    <label htmlFor="confirmPassword">Confirm Password <span className="text-danger">*</span></label>
                    <Form.Control.Feedback type="invalid">
                      {errors.confirmPassword} {/* Corrected to show confirmPassword error */}
                    </Form.Control.Feedback>
                  </Form.Floating>
                  <span onClick={toggleConfirmPasswordVisibility} className="password-toggle-icon">
                    {showConfirmPassword ? <BsEye size={20} /> : <BsEyeSlash size={20} />}
                  </span>
                </div>
              </Form.Group>
            </Row>

            <Row className="mt-2 d-flex align-items-center justify-content-center h-auto gx-3">
              {/* Mobile Number Field */}
              <Form.Group as={Col} md={6} controlId="mobileNo" className="mt-md-0 p-1 form-group-fixed-height">
                <Form.Floating>
                  <Form.Control type="tel" name="mobileNo" placeholder="Mobile Number" onChange={handleChange} isInvalid={!!errors.mobileNo} required />
                  <label htmlFor="mobileNo">Mobile Number <span className="text-danger">*</span></label>
                  <Form.Control.Feedback type="invalid">{errors.mobileNo}</Form.Control.Feedback>
                </Form.Floating>
              </Form.Group>

              {/* Date of Birth Field */}
              <Form.Group as={Col} md={6} controlId="dob" className="mt-md-0 p-1 form-group-fixed-height">
                <Form.Floating>
                  <Form.Control type="date" name="dob" placeholder="Date of Birth" onChange={handleChange} required />
                  <label htmlFor="dob">Date of Birth <span className="text-danger">*</span></label>
                </Form.Floating>
              </Form.Group>
            </Row>

            <Row className="h-auto">
              <Col md={6} className="p-1 h-auto m-0">
                <Form.Group controlId="whatsappCheck m-0">
                  <Form.Check
                    type="checkbox"
                    name="sameAsWhatsapp"
                    label="My WhatsApp number is the same as my mobile number"
                    checked={isWhatsappSame}
                    onChange={handleCheckboxChange}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className="mb-3">
              <Form.Label>Gender <span className="text-danger">*</span></Form.Label>
              <div className="d-flex gap-3 gender-group ">
                {["Male", "Female", "Other"].map((g) => (
                  <Form.Check type="radio" name="gender" value={g} label={g} key={g} onChange={handleChange} />
                ))}
              </div>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Floating>
                <Form.Control as="textarea" name="address" placeholder="Address" style={{ height: '100px' }} onChange={handleChange} />
                <label htmlFor="address">Address<span className="text-danger">*</span></label>
              </Form.Floating>
              <Form.Text muted className="d-flex align-items-center">
                <BsInfoCircle className="me-2" /> {/* Icon with margin */}
                Include pin code in address.
              </Form.Text>
            </Form.Group>

            <Form.Group className="my-4 d-flex align-items-center">
              <Form.Check
                type="checkbox"
                name="termsAccepted"
                onChange={handleChange}
                isInvalid={!!errors.termsAccepted}
                feedback={errors.termsAccepted}
                feedbackType="invalid"
                required // Added required for consistency
                label={
                  <>
                    I accept the  <span> </span>
                    <a href="/terms-conditions" target="_blank" rel="noopener noreferrer">
                         Terms & Conditions
                    </a>
                    <span className="text-danger">*</span>
                  </>
                }
              />
            </Form.Group>

            <div className="d-grid">
              <Button
                type="submit"
                className={`register-btn ${loading ? "disabled" : ""}`}>
                {loading ? <section id="spinner section"><span className="spinner-border spinner-border-sm spinner"></span></section> : "Register"} {/* Changed to "Register" for context */}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default RegistrationForm;
